import authAxios from '../config/authAxios';
import { avisoError, avisoCorrecto, avisoCargando } from '../view/components/AvisosMensajes/MensajesSwalf';
import Swal from 'sweetalert2/dist/sweetalert2.js';

export const PROTOCOLO_LOADING  = 'PROTOCOLO_LOADING';
export const PROTOCOLO_OBTENIDO = 'PROTOCOLO_OBTENIDO';
export const PROTOCOLO_ERROR    = 'PROTOCOLO_ERROR';
export const PROTOCOLO_ITEM_OK  = 'PROTOCOLO_ITEM_OK';

export const REPORTE_LOADING    = 'REPORTE_LOADING';
export const REPORTE_OBTENIDO   = 'REPORTE_OBTENIDO';
export const REPORTE_ERROR      = 'REPORTE_ERROR';
export const REPORTE_ENVIADO    = 'REPORTE_ENVIADO';
export const REPORTE_ACCION_OK  = 'REPORTE_ACCION_OK';
export const REPORTE_ACCION_DEL = 'REPORTE_ACCION_DEL';

export const KPIS_LOADING  = 'KPIS_LOADING';
export const KPIS_OBTENIDO = 'KPIS_OBTENIDO';
export const KPIS_ERROR    = 'KPIS_ERROR';

export const obtenerProtocolo = (idSesion, idUsuario) => async dispatch => {
  dispatch({ type: PROTOCOLO_LOADING });
  try {
    const res = await authAxios.get(`/admin/tutoria/protocolo/${idSesion}`, {
      params: { id_usuario: idUsuario }
    });
    if (res.data.ok) {
      dispatch({ type: PROTOCOLO_OBTENIDO, payload: res.data });
    } else {
      dispatch({ type: PROTOCOLO_ERROR });
      avisoError(res.data.msg || 'Error al cargar protocolo');
    }
  } catch (e) {
    dispatch({ type: PROTOCOLO_ERROR });
    avisoError('Error de conexión');
  }
};

export const guardarItemProtocolo = (idDetalle, data) => async dispatch => {
  try {
    const res = await authAxios.put(`/admin/tutoria/protocolo/item/${idDetalle}`, data);
    if (res.data.ok) {
      dispatch({
        type: PROTOCOLO_ITEM_OK,
        payload: { idDetalle, data, estado_protocolo: res.data.estado_protocolo }
      });
    }
  } catch (e) {
    avisoError('Error al guardar item');
  }
};

export const obtenerReporte = (idSesion, idUsuario) => async dispatch => {
  dispatch({ type: REPORTE_LOADING });
  try {
    const res = await authAxios.get(`/admin/tutoria/reporte/${idSesion}`, {
      params: { id_usuario: idUsuario }
    });
    if (res.data.ok) {
      dispatch({ type: REPORTE_OBTENIDO, payload: res.data });
    } else {
      dispatch({ type: REPORTE_ERROR });
      avisoError(res.data.msg || 'Error al cargar reporte');
    }
  } catch (e) {
    dispatch({ type: REPORTE_ERROR });
    avisoError('Error de conexión');
  }
};

export const guardarReporte = (idReporte, data, silencioso = true) => async dispatch => {
  try {
    const res = await authAxios.put(`/admin/tutoria/reporte/${idReporte}`, data);
    if (res.data.ok && !silencioso) {
      avisoCorrecto('Borrador guardado');
    }
  } catch (e) {
    avisoError('Error al guardar reporte');
  }
};

export const enviarReporte = idReporte => async dispatch => {
  const result = await Swal.fire({
    title: '¿Enviar reporte?',
    text: 'Una vez enviado no podrás editarlo',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Sí, enviar',
    cancelButtonText: 'Cancelar',
    confirmButtonColor: '#28a745',
    cancelButtonColor: '#dc3545',
  });
  if (!result.isConfirmed) return;

  try {
    avisoCargando('Enviando...');
    const res = await authAxios.post(`/admin/tutoria/reporte/${idReporte}/enviar`);
    if (res.data.ok) {
      dispatch({ type: REPORTE_ENVIADO, payload: res.data.fecha_envio });
      avisoCorrecto('Reporte enviado correctamente');
    } else {
      avisoError(res.data.msg || 'Error al enviar');
    }
  } catch (e) {
    avisoError('Error de conexión');
  }
};

export const agregarAccion = (idReporte, data) => async dispatch => {
  try {
    const res = await authAxios.post(`/admin/tutoria/reporte/${idReporte}/accion`, data);
    if (res.data.ok) {
      dispatch({
        type: REPORTE_ACCION_OK,
        payload: { id_accion: res.data.id_accion, id_reporte: idReporte, ...data }
      });
    }
  } catch (e) {
    avisoError('Error al agregar acción');
  }
};

export const obtenerKpisTutoria = idUsuario => async dispatch => {
  dispatch({ type: KPIS_LOADING });
  try {
    const res = await authAxios.get(`/admin/tutoria/kpis/${idUsuario}`);
    if (res.data.ok) {
      dispatch({ type: KPIS_OBTENIDO, payload: res.data.data });
    } else {
      dispatch({ type: KPIS_ERROR });
    }
  } catch (e) {
    dispatch({ type: KPIS_ERROR });
  }
};

export const eliminarAccion = idAccion => async dispatch => {
  try {
    await authAxios.delete(`/admin/tutoria/reporte/accion/${idAccion}`);
    dispatch({ type: REPORTE_ACCION_DEL, payload: idAccion });
  } catch (e) {
    avisoError('Error al eliminar acción');
  }
};
